import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DistributorsComponent } from './distributors.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      { path:'DistributorsModule', loadChildren: () => import('./distributors.module').then(m => m.DistributorsModule)},
      { path: '', component: DistributorsComponent }
    ])
  ],
  exports: [RouterModule]
})
export class DistributorsRoutingModule { }
